/**
 * Created by bdickson on 15/06/2016.
 */

namespace TR {

    class BookingExtrasOptionOld {

        model:any;
        val:any;
        group:string;
        selected:boolean;
        price:number;
        perPerson:boolean;
        pricePerPerson:number;
        priceFull?: number;
        included?: boolean;
        priceRounded?: boolean;

        private _input:any;

        constructor($scope:ng.IScope) {
            // watch the model
            $scope.$watch('beo.model', model => {
                this._checkSelected();
            });
        }

        click(event:MouseEvent) {
            // update the model only if the value has changed
            if (!angular.equals(this.model, this.val)) {
                this.model = this.val;
            }
        }

        private _checkSelected() {
            this.selected = angular.equals(this.model, this.val);
            //this._input.prop('checked', this.selected);
        }

        // init(container:ng.IAugmentedJQuery) {
        //     this._input = container.find('input');
        // }

    }

    angular
        .module('TR')
        .directive('bookingExtrasOptionOld', ():ng.IDirective => {

            return {
                scope: {},
                bindToController: {
                    model: '=',
                    val: '=',
                    group: '@',
                    price: '=',
                    perPerson: '=',
                    pricePerDay: '=',
                    isDelta: '=?',
                    pricePerPerson: '=?',
                    priceFull: '=?',
                    included: '=?',
                    priceRounded: '=?'
                },
                controller: BookingExtrasOptionOld,
                controllerAs: 'beo',
                templateUrl: 'partials/home/directivetemplate?type=BookingExtrasOptionOld',
                transclude: true,
                replace: true,

                // link: function (scope:ng.IScope, el:ng.IAugmentedJQuery, attr, controller:BookingExtraOption) {
                //     controller.init(el);
                // }

            };

        });

}
